module.exports = __webpack_public_path__ + "static/media/tmdb_logo.0f4a7f74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tmdb_logo.svg
// module id = 26
// module chunks = 0